export interface TXdocsSearchScope {
  calculatedFields: boolean;
  answerFields: boolean;
  content: boolean;
}

export enum SearchScope {
  Body = 'Body',
  HeadersFooters = 'HeadersFooters',
}
